import React , {useState, useEffect} from "react";

import ProInputText from "../common/ProInputText";
import ProFormFooter from "../common/ProFormFooter";

import { useFormik } from "formik";
import { useHierarchyService } from "../../hooks/useHierarchyService";
import { useDialogService } from "../../hooks/useDialogService";
import useSetup from "../../hooks/useSetup";
import useFormServices from "../../hooks/useFormServices";

import { SearchTree, GetNode, ValidateCharacters, ExceedsBedLimit, Severity } from "../../constants/ProConstants";
import _ from "lodash";
import "primeflex/primeflex.css";

const ProDuplicateForm = ({
    showFooter = false,
    closeSideBar = () => console.log("close"), formModel = {}, formAction
}) => {
    const {data:{activeTree, selectedTreeNode}} = useHierarchyService();
    const {actions:{ShowDialog}} = useDialogService();
    const { actions:{DuplicateNode}} = useSetup({refreshTree:false});
    const {actions:{Initialize, ConfirmFormAction, UpdateFormState}} = useFormServices()
    const [isMounted, setIsMounted] = useState(false)

    const formik = useFormik({
        initialValues: {
            type: _.isEmpty(formModel) ? {} : formModel.type,
            model: {
                ...formModel.model,
                name: 'Copy Of ' + _.get(formModel, 'model.name'),

            }
        },
        validate: (data) => {
            let errors = {};
            if (_.isEmpty(data.model.name)) {
                errors.name = `${data.type.name} is required.`;
            }
            if (!_.isEmpty(data.model.name) && data.model.name.length > 120) {              
                errors.name = "Max 120 characters allowed";
            } 
            if (!_.isEmpty(data.model.name) && !ValidateCharacters(data.model.name)) {              
                errors.name = "Invalid Characters";
            } 
            var element;
            switch (data.type.code) {
                case 'BUILDING':
                    element = SearchTree(activeTree, "label", `${_.trimStart(_.trimEnd(data.model.name))}`);
                    if (!_.isNull(element)) {
                        errors.name = `${data.type.name} name already exists!`;
                    }
                    break;
                case 'FLOOR':
                case 'WING':
                case 'UNIT':
                case 'ROOM':
                    if (_.get(data.model.building, "name")) {
                        element = SearchTree(SearchTree(activeTree, "label", (_.isEqual(data.model.parentType.code, "BUILDING") || _.isEmpty(data.model.parent)) ? data.model.building.name : data.model.parent.name), "label", `${_.trimStart(_.trimEnd(data.model.name))}`);
                        if (!_.isNull(element))
                            errors.name = `${data.type.name} name already exists!`;
                    }
                    break;
                case 'BED':
                    if (_.get(data.model.building, "name")) {
                        var element =  SearchTree(SearchTree(activeTree, "key", data.model.room.key), "label", `${_.trimStart(_.trimEnd(data.model.name))}`, data.model.room.key);
                        if(!_.isNull(element))
                            errors.name =  "Bed name already exists!";                       
                    }
                    break;
                default:
                    break;
            }
            if(!_.isEmpty(data.type.code))
                UpdateFormState(true)   

            return errors;
        },
        onSubmit: (data) => {
            handleSubmit(data);
        },
    }); 


    useEffect(()=>{         
        if(!isMounted){
            setIsMounted(true);           
            Initialize(closeSideBar)
            UpdateFormState(true)
        }
        if(isMounted){            
            ConfirmFormAction();            
        }      
            
    }, [selectedTreeNode])

    useEffect(()=>{
        return ()=>{  
            UpdateFormState(false)                   
        }
    }, [])


    const handleSubmit = async(data) => {
        if(data.type.code === "BED" && ExceedsBedLimit(activeTree, data.model)){  
                await ShowDialog("Add Bed and Exceed Capacity?", "Adding this bed exceeds the bed capacity defined at a parent level.  Are you sure you wish to proceed?", null, "Yes, Add Bed", "Cancel", Severity.Danger,
                async ()=>{
                   await DuplicateNode(GetNode(data), {id: data.model.id, name:_.trimStart(_.trimEnd(data.model.name)), type: data.type.code});
                   closeSideBar();
                },
                ()=>{
                    console.log("Add not confirmed"); 
                    closeSideBar();
                })                
        } 
        else {       
            DuplicateNode(GetNode(data), {id: data.model.id, name:_.trimStart(_.trimEnd(data.model.name)), type: data.type.code});
            closeSideBar();
        }
    };

    return (
        <form onSubmit={formik.handleSubmit}>
            <ProInputText
                headerText="Name"
                id="name"
                labelText="Name"
                value={formik.values.model.name}
                onChange={(e) => {
                    formik.setValues({ ...formik.values, model: { ...formik.values.model, name: e.target.value } });
                }}
                formik={formik}
                name="name"
                error="name"
                required
            />
            {showFooter && (<ProFormFooter onSave={() => console.log("Save")} onCancel={closeSideBar} />)}
        </form>
    );
};

export default ProDuplicateForm;
